import { render, staticRenderFns } from "./JoinTextObjectMenu.vue?vue&type=template&id=eab1ffa4&"
import script from "./JoinTextObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./JoinTextObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./JoinTextObjectMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports